// extracted by mini-css-extract-plugin
export default {"root":"Login_root__GpTVI","card":"Login_card__8yL0b","error":"Login_error__oZQ-6"};